module.exports = __webpack_public_path__ + "img/bitcoin-btc-logo.f92890de.svg";